import React, { useState, useRef, useEffect } from 'react';
import { IoIosNotifications } from 'react-icons/io';
import { Link, Route, Routes } from 'react-router-dom';
import { Sidebar } from '../components';
import UserProfile from '../components/ProfileComponents/UserProfile';
import { client } from '../client';
import { v4 as uuidv4 } from 'uuid';
import Pins from './Pins';
import { userQuery } from '../utils/data';
import { fetchUser } from '../utils/FetchUser';
import Spinner from '../components/Spinner';
import AddFamily from '../components/AddFamily';
import CreateFamily from '../components/CreateFamily';
import FamilyDetails from '../components/FamilyDetails';
import CreatePin from '../components/CreatePin';
import Search from '../components/Search';
import NavButtons from '../components/NavButtons';
import Calendar from '../components/FamilyComponents/Calendar';
import { Badge } from '@mui/material';
import Notifications from '../components/Notifications/Notifications';

const Home = () => {
  const [view, setView] = useState('');
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState([])
  const scrollRef = useRef(null);

  const userInfo = fetchUser();

  useEffect(() => {
    const query = userQuery(userInfo?.sub);

    client.fetch(query)
      .then((data) => {
        setUser(data[0]);
        setNotification(data[0].notifications)
      })
  }, [userInfo?.sub]);

  useEffect(() => {
    const query = '*[(_type == "conversation" || _type == "pin" || _type == "vid") && references($id)]'
    const params = { id: userInfo?.sub };
    const subscription = client
      .listen(query, params)
      .subscribe(update => {
        // const comment = update.result;
        const person = update.mutations[0].patch.insert.items[0].commenter;
        const note = person.userName + " commented on your post";
     
        if (person._id !== update.result.postedBy._ref) {
          client
            .patch(update.result.postedBy._ref)
            .setIfMissing({ notifications: [] })
            .insert('after', 'notifications[-1]', [{
              _key: uuidv4(), 
              commenter: person,
              postId: update.mutations[0].patch.id,
              message: note,
              type: update.result._type,
            }])
            .commit() // Perform the patch and return a promise
            .then((doc) => {
              console.log('Hurray, Profile is updated! New document:');
              console.log(doc);
            })
            .catch((err) => {
              console.error('Oh no, the update failed: ', err.message);
            })
        }else{
          console.log("no match");
          console.log(update.mutations[0].patch.insert.items[0].postedBy._ref);
        }
      })


    return () => {
      subscription.unsubscribe();
    }
  })

  useEffect(() => {
    scrollRef.current.scrollTo(0, 0);
  });

  return (
    <div className='flex bg-gray-50 md:flex-row flex-col h-screen transaction-height duration-75 ease-out'>
      <div className="hidden md:flex h-screen flex-initial">
        <Sidebar user={user && user} />
      </div>
      <div className="flex md:hidden flex-row h-10">
        <div className='flex items-center justify-start w-full'>
          <p className='font-bold pl-2'>{view}</p>
        </div>
        <div className="w-auto flex shadow-b-md">
          {/* <Link to="/">
            <img src={logo} alt="logo" className="w-28 h-auto" />
          </Link> */}

        </div>
        <div className='flex items-center justify-center w-auto shadow-b-md'>
          <Badge
            badgeContent={notification?.length}
            color="primary"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}>
            <Link to={`/notifications/${user?._id}`}>
              <IoIosNotifications className='text-2xl' />
            </Link>
          </Badge>
        </div>
      </div>
      {loading && (
        <Spinner />
      )}
      <div className="bg-mainBg pb-2 flex-1 h-screen overflow-y-scroll" ref={scrollRef}>
        <Routes>
          <Route path="/user-profile/:userId" element={<UserProfile setView={setView} />} />
          <Route path="/notifications/:userId" element={<Notifications setView={setView} notifications={notification} setNotifications={setNotification} />} />
          <Route path="/Family" element={<AddFamily user={user && user} setView={setView} />} />
          <Route path="/*" element={<Pins user={user && user} setView={setView} />} />
          <Route path="/family-detail/:famId" element={<FamilyDetails user={user && user} setView={setView} />} />
          <Route path="/create-pin" element={<CreatePin user={user && user} setView={setView} />} />
          <Route path="/search" element={<Search user={user && user} />} setView={setView} />
          <Route path="/create-family" element={<CreateFamily user={user && user} setView={setView} />} />
          <Route path="/calendar" element={<Calendar user={user && user} setView={setView} />} />
        </Routes>
      </div>
      <NavButtons user={user && user} />
    </div>
  )
}

export default Home
